import { useMemo } from "react";
import type { DeepReadonly } from "ts-essentials";

import { readState } from "@/__main__/app-state.mjs";
import type { PaymentProviderType } from "@/feature-wallet/models/payment-method-provider.mjs";
import type { UserPaymentProvider } from "@/feature-wallet/models/user-payment-methods.mjs";
import { useSnapshot } from "@/util/use-snapshot.mjs";

export function getPaymentProvider<T extends PaymentProviderType>({
  paymentProviders,
  providerType,
}: {
  paymentProviders: DeepReadonly<UserPaymentProvider[]>;
  providerType: T;
}): Extract<UserPaymentProvider, { providerType: T }> {
  for (const paymentProvider of paymentProviders) {
    if (paymentProvider.providerType === providerType) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return paymentProvider as any;
    }
  }

  return null;
}

export function usePaymentProvider<T extends PaymentProviderType>(
  providerType: T,
): Extract<UserPaymentProvider, { providerType: T }> {
  const { paymentProviders } = useSnapshot(readState.wallet);

  return useMemo(
    () => getPaymentProvider({ paymentProviders, providerType }),
    [paymentProviders, providerType],
  );
}
